import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  Checkbox,
  PanelToggle,
  PANEL_TOGGLE_TITLE_VARIANT_S,
  Flex
} from 'mailup-web-components'

import { useRecoilState } from 'recoil'
import { messageState } from '../../../recoil/state/message'
import ReactTooltip from 'react-tooltip'

const AutomaticLinkTracking = () => {
  const intl = useIntl()
  const staticProtocolModel = [
    { label: 'HTTP', protocol: 'http:', checked: false },
    { label: 'HTTPS', protocol: 'https:', checked: false },
    { label: 'Mailto', protocol: 'mailto:', checked: false },
    { label: 'FTP', protocol: 'ftp:', checked: false },
    { label: 'News', protocol: 'news:', checked: false },
    { label: 'Tel', protocol: 'tel:', checked: false }
  ]

  const [
    { trackingInfoEnabled, trackingInfoProtocols },
    setTrakingInfo
  ] = useRecoilState(messageState)

  function onClickSetTrackingInfo(checkState) {
    setTrakingInfo(prev => ({
      ...prev,
      trackingInfoEnabled: !checkState,
      isDirty: true
    }))
  }

  const handleCheckChange = e => {
    const oldItems = trackingInfoProtocols.map(e => e)
    const checked = e.target.checked
    if (checked) {
      oldItems.push(e.target.value)
    } else {
      oldItems.splice(
        oldItems.findIndex(i => i === e.target.value),
        1
      )
    }
    setTrakingInfo(prev => ({
      ...prev,
      trackingInfoProtocols: oldItems,
      isDirty: true
    }))
  }

  useEffect(() => {
    ReactTooltip.rebuild()
  }, [])

  const staticProtocols = staticProtocolModel.map(e => {
    const props = () => ({
      label: e.label,
      labelClassName: '',
      onChange: handleCheckChange,
      checked: trackingInfoProtocols.includes(e.protocol),
      value: e.protocol
    })
    return (
      <div key={e.protocol}>
        <Checkbox
          {...props()}
          data-mu-test={'overview-message__check_' + e.protocol}
        />
      </div>
    )
  })

  return (
    <>
      <PanelToggle
        title={intl.formatMessage({
          id: 'Load.SavedEmailWizard.LabelAutomaticLinkTracking'
        })}
        titleVariant={PANEL_TOGGLE_TITLE_VARIANT_S}
        titleTooltip={intl.formatMessage({
          id: 'Load.SavedEmailWizard.AutomaticLinkTrackingTooltip'
        })}
        checked={trackingInfoEnabled}
        onChange={() => onClickSetTrackingInfo(trackingInfoEnabled)}
        data-mu-test='overview-message__box-automatic-link-tracking'
      >
        {trackingInfoEnabled && (
          <Flex alignItems='center' margin='8px 0 0 0' columnGap='32px'>
            {staticProtocols}
          </Flex>
        )}
      </PanelToggle>
    </>
  )
}

export default AutomaticLinkTracking
